/**
 * Rivaro — Color swatch hover preview en product cards.
 * Approach bulletproof: cambia src/srcset de la imagen original en hover.
 * No agrega elementos nuevos al DOM (evita conflictos con CSS de Trade theme).
 */
(function () {
  if (!('querySelector' in document)) return;

  function findCardRoot(swatchesContainer) {
    return (
      swatchesContainer.closest('.card-wrapper') ||
      swatchesContainer.closest('[class*="card-product"]') ||
      swatchesContainer.closest('[class*="card__inner"]') ||
      swatchesContainer.closest('article') ||
      swatchesContainer.parentElement
    );
  }

  function findCardImage(card) {
    if (!card) return null;
    var img = card.querySelector(
      '.card__media img, [class*="media"] img, [class*="card__image"] img'
    );
    return img || card.querySelector('img');
  }

  function setupCard(swatchesContainer) {
    var card = findCardRoot(swatchesContainer);
    if (!card) return;
    var img = findCardImage(card);
    if (!img) return;

    // Guardar el estado original UNA sola vez
    if (!img.dataset.rivaroOriginalSrc) {
      img.dataset.rivaroOriginalSrc = img.getAttribute('src') || '';
      img.dataset.rivaroOriginalSrcset = img.getAttribute('srcset') || '';
    }

    var swatches = swatchesContainer.querySelectorAll('a.rivaro-card-swatch');
    var loadedUrls = {};
    var hoverToken = 0;

    function preload(url) {
      if (!url || loadedUrls[url]) return;
      loadedUrls[url] = true;
      var pre = new Image();
      pre.src = url;
    }

    function applyPreview(url) {
      var token = ++hoverToken;
      var probe = new Image();
      function swap() {
        if (token !== hoverToken) return; // hover ya cambió, ignorar
        img.setAttribute('src', url);
        img.removeAttribute('srcset'); // evita que srcset overridee el src
      }
      if (probe.complete && probe.naturalWidth > 0) {
        swap();
      } else {
        probe.addEventListener('load', swap, { once: true });
        probe.src = url;
      }
    }

    function restoreOriginal() {
      hoverToken++;
      var orig = img.dataset.rivaroOriginalSrc;
      var origSet = img.dataset.rivaroOriginalSrcset;
      if (orig) img.setAttribute('src', orig);
      if (origSet) img.setAttribute('srcset', origSet);
      else img.removeAttribute('srcset');
    }

    swatches.forEach(function (sw) {
      var imgUrl = sw.getAttribute('data-color-image');
      if (!imgUrl) return;

      preload(imgUrl);

      sw.addEventListener('mouseenter', function () { applyPreview(imgUrl); });
      sw.addEventListener('mouseleave', restoreOriginal);
      sw.addEventListener('focusin', function () { applyPreview(imgUrl); });
      sw.addEventListener('focusout', restoreOriginal);
    });
  }

  function init() {
    var containers = document.querySelectorAll('[data-rivaro-card-swatches]');
    containers.forEach(setupCard);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
